export const patterns = {
    name: /^(?!.*([A-Za-zÁÉÍÓÚÜÑáéíóúüñ])\1{2,})[A-Za-zÁÉÍÓÚÜÑáéíóúüñ]{3,}(?:\s[A-Za-zÁÉÍÓÚÜÑáéíóúüñ]{3,})*$/,
    lastname: /^(?!.*([A-Za-zÁÉÍÓÚÜÑáéíóúüñ])\1{2,})[A-Za-zÁÉÍÓÚÜÑáéíóúüñ]{3,}(?:\s[A-Za-zÁÉÍÓÚÜÑáéíóúüñ]{3,})*$/,
    email: /^[a-zA-Z0-9._-]{2,}@[a-zA-Z.-]{2,}\.[a-zA-Z]{2,}$/,
    corporateEmail: /^[a-zA-Z0-9._-]{2,}@(?!gmail\.(com|co)$)(?!hotmail\.(com|co)$)(?!outlook\.(com|co)$)(?!yahoo\.(com|co)$)(?!live\.(com|co)$)(?!icloud\.(com|co)$)(?!mail\.(com|co)$)[a-zA-Z.-]{2,}\.[a-zA-Z]{2,}$/,
    phone: /^(?:300|301|302|303|304|305|310|311|312|313|314|315|316|317|318|319|320|321|322|323|324|333|350|351)(?!\d*(.)\1\1\1\1)(?!\d*1234)\d{7}$/,
    city: /^[a-zA-ZáéíóúÁÉÍÓÚ\s]{3,50}$/i,
    ingreso: /^(?:\$\s?)?\d{1,3}(?:\.\d{3})*(?:,\d+)?$/,
    nit: /[0-9]{7,}-[0-9]{1}$/,
    cargo: /^[A-Za-z\s]{3,30}$/i,
    company: /^[A-Za-z\s]{3,30}$/i,
    budget: /^\d{1,3}(?:\.\d{3}){2,}$/,
    fecha_cuota: /^\d{4}-\d\d-\d\d$/,
    propertyPrice: /^(?=.{13,})(\$ ?)?([1-9]\d{0,2}(?:\.\d{3})+|[1-9]\d{8,})$/, // 90 * 1423500 = 128115000
    min_budget: /^(?:\$\s?)?\d{1,3}(?:\.\d{3})*(?:,\d+)?$/,
};
export const addTextValidation = (elements) => {
    elements.forEach((input) => {
        input.addEventListener('keypress', function (e) {
            if (!e.code.includes('Key') &&
                e.code !== 'Semicolon' &&
                e.code !== 'Space' &&
                !(e.key.match(/[a-zA-Z0-9.@\-_]/))) {
                e.preventDefault();
            }
        }, true);
    });
};
export const numberFormat = (val) => new Intl.NumberFormat("es-ES", {
    maximumFractionDigits: 0,
}).format(Number(val));
export const getNumericValue = (val) => Number(val === null || val === void 0 ? void 0 : val.replace(/[.$\s]/g, ''));
export function getDeviceType() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ? "mobile" : "desktop";
}
/**
 * Opens or closes the additional content when clicked.
 * @param {Event} e - Click event on the "read more/less" button.
 * @returns {void}
 */
export function clickOpenText(e) {
    const target = e.target;
    const container = target.closest('.js-project-additional') || target.closest('.js-finishes') || target.closest('.js-description') || target.closest('.js-strata') || target.closest('.js-schedule');
    if (!container)
        return;
    const baseTargetId = target.getAttribute('data-text-target');
    if (!baseTargetId)
        return;
    const isMobile = window.innerWidth <= 768;
    let targetId = baseTargetId;
    if (targetId.includes('Summary')) {
        targetId = isMobile ? targetId + 'Mobile' : targetId + 'Desktop';
    }
    const fullTextBlock = container.querySelector('#' + targetId);
    const summaryBlocks = container.querySelectorAll('.js-hide-text');
    summaryBlocks.forEach((block) => {
        block.classList.add('hide');
    });
    if (fullTextBlock === null || fullTextBlock === void 0 ? void 0 : fullTextBlock.classList.contains('hide')) {
        fullTextBlock.classList.remove('hide');
    }
    else {
        fullTextBlock === null || fullTextBlock === void 0 ? void 0 : fullTextBlock.classList.add('hide');
        summaryBlocks.forEach((block) => {
            if (block !== fullTextBlock) {
                block.classList.remove('hide');
            }
        });
    }
}
